module.exports = __webpack_public_path__ + "static/media/add_blue_circle.8bcf7dac.svg";